import { useState } from "react";
import {
  Grid,
  Button,
  CardHeader,
  Dialog,
  DialogContent,
  DialogActions,
  Divider,
  RadioGroup,
  Radio,
  TextField,
  FormControlLabel,
  Loading,
} from "../../../../components";
import { ContasReceberService, notification } from "../../../../services";
import { responseErros, voltar } from "../../../../utils";
import contasReceberValidator from "../middlewares/add-contas-receber.validator";
import desdobrarTituloValidator from "../middlewares/desdobrarTitulo.validator";
import { useImportContext } from "../../../../contexts/import.context";

const tituloSecaoSx = {
  display: "block",
  fontSize: 12,
  fontWeight: 600,
  letterSpacing: 0.6,
  textTransform: "uppercase",
  color: "#6c757d",
  marginBottom: 4,
};

const DesdobrarTitulo = ({
  contaReceber,
  meioPagamento,
  dadosPagamentoList,
  observacaoList,
  inputErros,
  setInputErro,
}) => {
  const { initialCollapses } = useImportContext();
  const [loading, setLoading] = useState(false);
  const [openDesdobrarTitulo, setOpenDesdobrarTitulo] = useState(false);
  const [desdobramentoTitulo, setDesdobramentoTitulo] = useState({
    tipoDesdobramento: "QUANTIDADE",
  });
  const contasReceberValidatorService = contasReceberValidator(meioPagamento);
  const contasReceberService = new ContasReceberService();

  const handleCloseDesdobrarDialog = () => {
    setOpenDesdobrarTitulo(false);
  };

  const handleChange = (event) => {
    setDesdobramentoTitulo((prevState) => ({
      ...prevState,
      [event.target.name]: event.target.value,
    }));
  };

  const handleOpenDesdobrarDialog = () => {
    const body = {
      ...contaReceber,
      observacaoList,
      bancoCaixaId: meioPagamento?.bancoCaixaId || contaReceber?.bancoCaixaId,
      pagamentos: dadosPagamentoList,
    };
    setInputErro([]);
    contasReceberValidatorService
      .validate(body, { abortEarly: false })
      .then(() => {
        setOpenDesdobrarTitulo(true);
      })
      .catch((err) => {
        inputErros.set(err);
      });
  };

  const validarDesdobramentoTitulo = () => {
    setInputErro([]);
    desdobrarTituloValidator
      .validate(desdobramentoTitulo, { abortEarly: false })
      .then(() => {
        desdobrarTitulo();
      })
      .catch((err) => {
        inputErros.set(err);
      });
  };

  const desdobrarTitulo = async () => {
    const body = {
      desdobramentoTitulo,
      contaReceber: {
        ...contaReceber,
        observacaoList,
        bancoCaixaId: meioPagamento?.bancoCaixaId || contaReceber?.bancoCaixaId,
        pagamentos: dadosPagamentoList,
      },
    };
    setLoading(true);
    const res = await contasReceberService.desdobrarTitulo(body);
    setLoading(false);
    if (!res.isAxiosError) {
      notification.cadastroSucesso();
      initialCollapses();
      voltar();
    } else {
      responseErros(res);
    }
  };

  return (
    <>
      <Button
        variant="outlined"
        className="mt-3 mb-2"
        color="primary"
        aria-controls={openDesdobrarTitulo ? "split-button-menu" : undefined}
        aria-expanded={openDesdobrarTitulo ? "true" : undefined}
        aria-haspopup="menu"
        onClick={handleOpenDesdobrarDialog}
      >
        Desdobrar título
      </Button>
      <Dialog
        fullWidth
        maxWidth={"sm"}
        open={openDesdobrarTitulo}
        onClose={handleCloseDesdobrarDialog}
      >
        <CardHeader title="Desdobrar Título" className="m-2" />
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <span id="tipoDesdobramento" style={tituloSecaoSx}>
                Tipo de desdobramento
              </span>
              <RadioGroup
                aria-labelledby="tipoDesdobramento"
                name="tipoDesdobramento"
                value={desdobramentoTitulo?.tipoDesdobramento ?? ""}
                onChange={handleChange}
              >
                <FormControlLabel
                  value="QUANTIDADE"
                  control={<Radio />}
                  label="Criar parcelas com o mesmo valor"
                />
                <FormControlLabel
                  value="VALOR"
                  control={<Radio />}
                  label="Dividir o valor total entre as parcelas"
                />
              </RadioGroup>
            </Grid>
            <Grid item xs={12}>
              <Divider variant="fullWidth" />
            </Grid>
            <Grid item xs={6}>
              <TextField
                id="qtdParcelas"
                name="qtdParcelas"
                label="Quantidade de parcelas"
                variant="outlined"
                required
                type="number"
                onChange={handleChange}
                value={desdobramentoTitulo?.qtdParcelas ?? ""}
                fullWidth
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                id="intervaloDias"
                name="intervaloDias"
                label="Intervalo de dias"
                variant="outlined"
                required
                type="number"
                onChange={handleChange}
                value={desdobramentoTitulo?.intervaloDias ?? ""}
                fullWidth
              />
            </Grid>
          </Grid>
          <Loading loading={loading} />
        </DialogContent>
        <DialogActions sx={{ padding: "0.5rem 1.5rem 1.5rem !important" }}>
          <Button
            variant="contained"
            color="primary"
            onClick={validarDesdobramentoTitulo}
          >
            <i
              className="ph-fill ph-check-circle"
              style={{ color: "white", fontSize: 22, marginRight: 10 }}
            ></i>
            Confirmar
          </Button>
          <Button
            color="padrao"
            variant="contained"
            style={{ marginLeft: 10 }}
            onClick={handleCloseDesdobrarDialog}
          >
            <i
              className="ph-fill ph-x-circle"
              style={{ fontSize: 22, marginRight: 10 }}
            ></i>
            Cancelar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default DesdobrarTitulo;
